import { Paper, styled } from '@mui/material';

const PREFIX = 'SecuritiesChipContainer';

export const classes = {
  root: `${PREFIX}-root`,
  chip: `${PREFIX}-chip`,
};

export const StyledPaper = styled(Paper)(({ theme }) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    justifyContent: 'left',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
  },

  [`& .${classes.chip}`]: {
    margin: theme.spacing(0.8),
    textTransform: 'uppercase',
    fontWeight: 'bold',
    border: `2px solid ${theme.palette.primary.main}`,
  },
}));
